import { AbstractControl, FormControl, Validators } from '@angular/forms';

export class BaseForm {
	models: BaseFormModel[] = [];

	protected setModels(models: BaseFormModel[]) {
		this.models = models;
	}

	protected setFormGroupControls() {
		const formGroupFields: any = {};
		this.models?.forEach(model => {
			formGroupFields[model.key] = new FormControl({
				value: model['value'],
				disabled: model['disabled']
			});
			this.addValidator(model['rules'], formGroupFields[model.key]);
		});
		return formGroupFields;
	}

	protected getFieldByKey(key: string): any {
		return this.models?.filter(model => model.key === key)[0];
	}

	protected setNullOption(text: string): { key: number | null; value: string } {
		return { key: null, value: text || '-' };
	}

	protected setDropdownOptions(
		data: any,
		key: string,
		value: string
	): { key: number | null; value: string } {
		let dropdownObject: { key: number | null; value: string } = {
			key: null,
			value: '-'
		};
		if (data && key && value) {
			dropdownObject = {
				key: data[key],
				value: data[value]
			};
		}
		return dropdownObject;
	}
	protected setDropdownOptionsCustom(
		data: any,
		key: string,
		value: string
	): { key: number | null; value: string } {
		let dropdownObject: { key: number | null; value: string } = {
			key: null,
			value: '-'
		};
		if (data && key && value) {
			dropdownObject = {
				key: data[key],
				value: value
			};
		}
		return dropdownObject;
	}

	private addValidator(rules: any, control: AbstractControl) {
		if (!rules) {
			return [];
		}

		Object.entries(rules).map((rule: [string, any]) => {
			switch (rule[0]) {
				case 'required':
					control.addValidators(Validators.required);
					break;
				case 'minLength':
					control.addValidators(Validators.minLength(Number(rule[1]?.value)));
					break;
				case 'maxLength':
					control.addValidators(Validators.maxLength(Number(rule[1]?.value)));
					break;
				case 'pattern':
					control.addValidators(Validators.pattern(String(rule[1]?.value)));
					break;
				case 'valueExists':
					control.setErrors({ valueExists: rule[1]?.errorMessage });
					break;
				default:
					break;
			}
		});

		return;
	}
}

export interface BaseFormModel {
	key: string;
	label: string;
	value?: any;
	rules?: {
		maxLength?: { value: number; errorMessage: string };
		minLength?: { value: number; errorMessage: string };
		pattern?: { value: string; errorMessage: string };
		required?: boolean;
		email?: boolean;
		valueExists?: { errorMessage: string };
	};
	type?: string;
	[key: string]: any;
}

export interface DropdownObject {
	key: number | null;
	value: string;
}
